/**
 * The app's one QueryClient, in a module of its own so code outside React can
 * reach it: `entityChanged` (src/shared/entities/changed.ts) invalidates an
 * entity's list from a plain writer function. `main.tsx` provides it.
 */
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 5 * 60 * 1000, // 5 minutes
            retry: 2,
            refetchOnWindowFocus: false,
        },
    },
});
